import React from "react";
import { useTranslation } from "react-i18next";

import { standardizeScoreType } from "../../../../utils/score";

export interface IHealthIndexProps {
  healthIndex: string;
  pageType: "OrganizationDashboard" | "FacilityDetails";
}

export const HealthIndex: React.FC<IHealthIndexProps> = (props) => {
  const { t: _t } = useTranslation();
  const t = (key: string, params = {}) =>
    _t(`facilityDetailsPage.summary.${key}`, params);

  const { healthIndex, pageType } = props;

  const standardizedHealthIndex = standardizeScoreType(healthIndex ?? "A1");
  const healthIndexKey = `${pageType}_score_${standardizedHealthIndex}`;

  return (
    <div className="txt">
      <span className="points"></span>
      <div>{t(healthIndexKey)}</div>
    </div>
  );
};
